import { ReactNode } from 'react';

import { Stack, StackProps } from '../stack';

export type ButtonGroupProps = Omit<StackProps, 'align'> & {
  children: ReactNode;
  align: 'left' | 'right' | 'center';
};

export const ButtonGroup = ({
  children,
  align = 'right',
  space = 2,
  ...rest
}: ButtonGroupProps) => {
  return (
    <Stack
      space={space}
      orientation="horizontal"
      {...rest}
      justify={align === 'right' ? 'flex-end' : align === 'left' ? 'flex-start' : 'center'}
    >
      {children}
    </Stack>
  );
};
